import React from "react";
import { Box, Divider, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import StanzaIcon from "src/assets/svg/stanza-small-icon.js";

const SentLinkSuccessfully = ({ email, handleSendEmail, isLoading }) => {
  return (
    <>
      <Box
        component={RouterLink}
        to="/"
        aria-label="Stanza home"
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 2,
          lineHeight: 0,
        }}
      >
        <StanzaIcon style={{ width: 36, height: 40, cursor: "pointer" }} />
      </Box>
      <Typography variant="h2" sx={{ mb: 1.5 }}>
        Check your email to continue
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ maxWidth: "80%", margin: "0 auto" }}>
        We've sent an email to <b style={{ color: "#000000" }}>{email}</b>. Click the magic link
        inside to continue.
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: "80%", margin: "16px auto 0" }}>
        Don't see it? Check your <b>spam</b> or <b>Promotions</b> folder.
      </Typography>
      <Divider sx={{ maxWidth: "80%", margin: "0 auto", mt: 4, mb: 2 }} />
      <Typography variant="body2" color="text.secondary">
        Didn't get the email?{" "}
        <Link
          component="button"
          type="button"
          onClick={() => handleSendEmail({ resend: true })}
          disabled={isLoading}
          sx={{ verticalAlign: "baseline", fontWeight: 500 }}
        >
          Try again
        </Link>
      </Typography>
    </>
  );
};

export default SentLinkSuccessfully;
